import { BtnGroup, BtnToolbar, Button, ButtonAction, PageTitle } from '@dec/shared';
import * as Icon from 'react-bootstrap-icons';
import { CheckCircleFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { CurrentAccountTaxpayerStatsCard } from '@/app/modules/current-account/components/CurrentAccountTaxpayerStatsCard';
import { TaxReturnCard } from '@/app/modules/tax-returns/components/TaxReturnCard';

export const TaxReturnSurccessPage = () => {
  // se recupera el identificador del pago
  const { id } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const onCancel = () => {
    const url = '/';
    navigate(url);
  };

  return (
    <div>
      <PageTitle
        title={t('taxReturns.taxReturn')}
        subtitle={t('taxReturns.reception')}
        icon={Icon.FileEarmarkText}
      />

      <div className={`alert alert-success fw-bold`}>
        <div className="d-flex justify-content-start gap-4 mt-0">
          <div className="me-4">
            <CheckCircleFill size={45} />
          </div>
          <div>
            <div>
              <h3> {t(`taxReturns.recordSuccess`)}</h3>
            </div>
            <div className="text-muted">{t(`taxReturns.recordSuccessNotes`)}</div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <TaxReturnCard id={id!} />
        </div>
        <div className="col-12 col-md-4">
          <CurrentAccountTaxpayerStatsCard col={12} />
        </div>
      </div>

      <BtnToolbar>
        <BtnGroup>
          {' '}
          <></>{' '}
        </BtnGroup>
        <BtnGroup>
          <Button action={ButtonAction.close} variant="secondary" onClick={onCancel} />
        </BtnGroup>
      </BtnToolbar>
    </div>
  );
};
